import { Box, Button, Drawer, FormControlLabel, Stack, Switch, Tooltip, Typography } from '@mui/material';
import { useFurnituresStore } from '@src/v3.0.0/store/furnitures/store';
import CloseIcon from '@mui/icons-material/Close';
import { useCropperStore } from '@src/v3.0.0/store/cropper/cropper-store';
import { useEffect } from 'react';
import { CreateScreenshot } from './FurnitureScreenshot';

export function FurnitureDrawer() {
  const cropperStore = useCropperStore();
  const {
    drawerIsShown,
    setDrawerShown,
    setGlobalVisibility,
    itemsVisible,
    addItem,
    empty: emptyTheStore,
    furnitures: availableFurnitures
  } = useFurnituresStore();
  
  useEffect(() => {
    if (cropperStore.element) {
      // setDrawerShown(true);
      // addItem(availableFurnitures[0]);
    }
  }, [cropperStore.element]);

  const onClose = () => {
    setDrawerShown(false);
  }

  const onVisibilityChange= () => {
    setGlobalVisibility(!itemsVisible);
  }

  const onDragStart = (e, furniture) => {
    e.dataTransfer.setData("furnitureName", furniture.name);
  };

  return (
    <Drawer
      anchor={"right"}
      open={drawerIsShown}
      onClose={onClose}
      hideBackdrop
      variant="persistent"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: 380,
          background: "rgba(255,255,255,0.2)",
          color: "#000",
          backdropFilter: "blur(2em)",
        },
      }}>
      <Box>
        <Stack direction={"row"} gap={2} p={2} pb={0} alignItems={"center"}>
          <Button startIcon={<CloseIcon />} onClick={onClose} size="small">
            Chiudi
          </Button>
          <Typography sx={{ color: "text.secondary" }}>
            Forniture da interno
          </Typography>
        </Stack>
        <Stack direction={"row"} gap={2} p={2} mb={2} alignItems={"center"}>
          <Stack>
            <FormControlLabel control={<Switch defaultChecked onChange={onVisibilityChange} />} label="Mostra oggetti" />
            <Button onClick={() => emptyTheStore()}>Rimuovi oggetti</Button>
          </Stack>
          <CreateScreenshot />
        </Stack>
        <Stack direction={"row"} flexWrap={"wrap"}>
          {availableFurnitures.map((furniture, idx) => (
            <Tooltip key={idx} title={`Aggiungi ${furniture.id}`}>
              <Button
                key={idx}
                draggable={true}
                onDragStart={e => onDragStart(e, furniture)}
                onMouseUp={() => addItem(furniture)}
                sx={{ padding: 0.2 }}>
                {furniture.img && (
                  <img
                    src={furniture.img}
                    style={{ objectFit: "contain", width: 60, height: 60 }}
                  />
                )}
                {furniture.Vector && (
                  <div style={{ width: 60, height: 60 }}>
                    <furniture.Vector
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                )}
              </Button>
            </Tooltip>
          ))}
        </Stack>
      </Box>
    </Drawer>
  );
}